import React from 'react';
import OfferGrid from "../OfferGrid";

const OfferGridNoValidationWrapper = () => {
    return <OfferGrid/>;
};

export default OfferGridNoValidationWrapper;
